import Vue from 'vue'
import Router from 'vue-router'
import AuthLayout from '@/layouts/Auth'
import PublicLayout from '@/layouts/Public'
import MainLayout from '@/layouts/Main/index-v2'
import PassThrough from '@/layouts/PassThrough'

import store from '@/store'
import { i18n } from '@/i18n'
import NProgress from 'nprogress'
import { checkWarehouseAccess } from '@/utils/accessGuard'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch(err => {
    if (err && err.name !== 'NavigationDuplicated') throw err
  })
}

const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject)
  }
  return originalReplace.call(this, location).catch(err => {
    if (err && err.name !== 'NavigationDuplicated') throw err
  })
}

const router = new Router({
  base: process.env.BASE_URL,
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      component: MainLayout,
      meta: {
        authRequired: true,
        title: 'PowerBiz',
        hidden: true,
      },
      children: [

        {
          path: '/dashboard',
          meta: {
            title: `Powerbiz - ${i18n.t('sideBar.dashboard')}`,
            authRequired: true,
            key: 'dashboard',
          },
          component: () => import('./views/dashboard/index-v2.vue'),
        },
        {
          path: '/dashboardv2',
          meta: {
            title: `Powerbiz - ${i18n.t('sideBar.dashboard')} v2`,
            authRequired: true,
            key: 'dashboardv2',
          },
          component: () => import('./views/dashboard/index-v2.vue'),
        },


        {
          path: 'sales',
          component: PassThrough,
          name: 'sales',
          children: [
            {
              path: '/sales',
              name: 'sales.index',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.sales')}`,
                authRequired: true,
                key: 'sales',
              },
              component: () => import('@/views/sales/index.vue'),
            },
          ],
        },


        {
          path: 'fulfillment',
          component: PassThrough,
          name: 'fulfillment',
          children: [
            {
              path: '/fulfillment',
              name: 'fulfillment.index',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.fulfillment')}`,
                key: 'fulfillment',
                authRequired: true,
              },
              component: () => import('@/views/fulfillment/index.vue'),
              children: [
                {
                  path: '/fulfillment/detail',
                  name: 'fulfillment-details',
                  meta: {
                    title: `Powerbiz - ${i18n.t('sideBar.fulfillment')}`,
                    key: 'fulfillment-detail',
                    authRequired: true,
                  },
                  component: () =>
                    import('@/components/Fulfillment/Detail/index.vue'),
                  children: [
                    {
                      path: '/fulfillment/detail/update-order',
                      name: 'fulfilment-edit-order',
                      meta: {
                        title: `Powerbiz - ${i18n.t('sideBar.fulfillment')}`,
                        authRequired: true,
                        key: 'fulfillment-detail-update-order',
                      },
                      component: () =>
                        import('@/components/Fulfillment/UpdateOrder'),
                    },
                  ],
                },
              ],
            },
            {
              path: '/fulfillment/export',
              name: 'fulfilment-export',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.fulfillment')}`,
                key: 'fulfillment-export',
                authRequired: true,
              },
              component: () => import('@/components/Fulfillment/Export'),
            },
            {
              path: '/fulfillment/label',
              name: 'fulfillment-label',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.fulfillment')}`,
                key: 'fulfillment-label',
                authRequired: true,
              },
              component: () =>
                import('@/components/Fulfillment/PrintLabel/index.vue'),
            },
            {
              path: ':id/revision',
              name: 'fulfillment-revision',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.fulfillment')}`,
                authRequired: true,
                key: 'fulfillment-revision-:id',
              },
              component: () => import('@/views/fulfillment/revision.vue'),
            },
          ],
        },


        {
          path: 'delivery-order',
          component: PassThrough,
          name: 'delivery-order',
          children: [
            {
              path: '/delivery-order',
              name: 'delivery-order.index',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.fulfillment')}`,
                key: 'delivery-order',
                authRequired: true,
              },
              component: () => import('@/views/delivery-order/index.vue'),
              children: [
                {
                  path: '/delivery-order/detail',
                  name: 'delivery-order-details',
                  meta: {
                    title: `Powerbiz - ${i18n.t('sideBar.fulfillment')}`,
                    key: 'delivery-order-detail',
                    authRequired: true,
                  },
                  component: () =>
                    import('@/components/DeliveryOrder/Detail/index.vue'),
                  children: [
                    {
                      path: '/delivery-order/detail/update-order',
                      name: 'delivery-order-edit-order',
                      meta: {
                        title: `Powerbiz - ${i18n.t('sideBar.fulfillment')}`,
                        authRequired: true,
                        key: 'delivery-order-detail-update-order',
                      },
                      component: () =>
                        import('@/components/DeliveryOrder/UpdateOrder'),
                    },
                  ],
                },
              ],
            },
            {
              path: '/delivery-order/export',
              name: 'delivery-order-export',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.fulfillment')}`,
                key: 'delivery-order-export',
                authRequired: true,
              },
              component: () => import('@/components/DeliveryOrder/Export'),
            },
            {
              path: '/delivery-order/label',
              name: 'delivery-order-label',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.fulfillment')}`,
                key: 'delivery-order-label',
                authRequired: true,
              },
              component: () =>
                import('@/components/DeliveryOrder/PrintLabel/index.vue'),
            },
          ],
        },

        {
          path: '/promotion-channel',
          component: PassThrough,
          name: 'promotion-channel:id',
          children: [
            {
              path: ':id/list',
              name: 'promotion-channel.promotion-list',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.promotion')} Channel`,
                authRequired: true,
                key: 'promotion-list-:id',
              },
              component: () => import('@/views/products/promo-channel/index.vue'),
            },
            {
              path: ':id/create',
              name: 'promotion-channel.promotion-create',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.promotion')}`,
                authRequired: true,
                key: 'promotion-create-:id',
              },
              component: () => import('@/views/products/promo-channel/create.vue'),
            },
            {
              path: ':id/edit/:promotionId',
              name: 'promotion-channel.promotion-edit',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.promotion')}`,
                authRequired: true,
                key: 'promotion-edit-:id',
              },
              component: () => import('@/views/products/promo-channel/create.vue'),
            },
          ],
        },


        {
          path: 'sales-channel',
          component: PassThrough,
          name: 'sales-channel',
          children: [
            {
              path: ':id',
              name: 'sales-channel.id',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.sales')} Channel`,
                authRequired: true,
                key: 'sales-channel-:id',
              },
              component: () => import('@/views/sales/index.vue'),
            },
          ],
        },

        {
          path: 'manual-order',
          component: PassThrough,
          name: 'manual-order',
          children: [
            {
              path: ':id',
              name: 'manual-order.id',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.sales')} Channel`,
                authRequired: true,
                key: 'manual-order-:id',
              },
              component: () => import('@/views/manual-order/index.vue'),
            },
            {
              path: ':id/create',
              name: 'sales.create',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.sales')}`,
                authRequired: true,
                key: 'sales',
              },
              component: () => import('@/views/manual-order/create.vue'),
            },
          ],
        },


        {
          path: 'sales-channel-kino',
          component: PassThrough,
          name: 'sales-channel-kino',
          children: [
            {
              path: ':id',
              name: 'sales-channel-kino.id',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.sales')} Channel Kino`,
                authRequired: true,
                key: 'sales-channel-kino:id',
              },
              component: () => import('@/views/sales/index.vue'),
            },
          ],
        },


        {
          path: 'channel/store',
          component: PassThrough,
          children: [
            {
              path: ':channelId',
              component: PassThrough,
              children: [
                {
                  path: 'product',
                  component: PassThrough,
                  children: [
                    {
                      path: '',
                      name: 'channel.store.product.index',
                      component: () => import('@/views/web-platform-channel/product/index.vue'),
                      meta: {
                        authRequired: true,
                        key: 'web-platform-product-channel-:id',
                      },
                    },
                    {
                      path: 'add',
                      name: 'channel.store.product.add',
                      component: () => import('@/views/web-platform-channel/product/add.vue'),
                    },
                    {
                      path: 'collection/:type?',
                      name: 'product-channel.product-collection',
                      component: () => import('@/views/web-platform-channel/product/collection/index.vue'),
                    },
                    {
                      path: 'collection/:type?',
                      name: 'channel.store.product.collection',
                      component: () => import('@/views/web-platform-channel/product/collection/index.vue'),
                    },
                    {
                      path: ':id',
                      name: 'channel.store.product.edit',
                      component: () => import('@/views/web-platform-channel/product/[id]/edit.vue'),
                    },
                  ],
                },
              ],
            },
          ],
        },


        {
          path: 'web-platform-product',
          component: PassThrough,
          name: 'web-platform-product-channel.index',
          children: [
            {
              path: ':id',
              name: 'web-platform-product-channel.product-master',
              redirect: (to) => {
                const { params, query } = to

                return {
                  name: 'channel.store.product.index',
                  query,
                  params: {
                    channelId: params.id,
                  },
                }
              },
            },
            {
              path: ':id/add-product',
              name: 'web-platform-product-channel.add-product',
              meta: {
                title: `Powerbiz - ${i18n.t('product.addProduct')} Channel`,
                authRequired: true,
                key: 'web-platform-product-channel-:id',
              },
              component: () =>
                import(
                  '@/views/web-platform-channel/products/add.vue'
                ),
            },
            {
              path: ':id/edit-product/:productId',
              name: 'web-platform-product-channel.edit-product',
              meta: {
                title: `Powerbiz - ${i18n.t('product.editProduct')} Channel`,
                authRequired: true,
                key: 'web-platform-product-channel-:id',
              },
              component: () =>
                import(
                  '@/views/web-platform-channel/products/edit.vue'
                ),
            },
          ],
        },

        {
          path: 'web-affiliate',
          component: PassThrough,
          name: 'web-affiliate.index',
          children: [
            {
              path: ':id',
              name: 'web-affiliate.id',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.reseller')} Channel`,
                authRequired: true,
                key: 'web-affiliate-:id',
              },
              component: () =>
                import('@/views/web-platform-channel/reseller/index.vue'),
              children: [
                {
                  path: 'detail',
                  name: 'web-affiliate.detail',
                  meta: {
                    title: `Powerbiz - ${i18n.t(
                      'sideBar.resellerdetail',
                    )} Channel`,
                    key: 'web-affiliate-:id',
                  },
                  component: () =>
                    import('@/views/web-platform-channel/reseller/detail'),
                },
              ],
            },
          ],
        },

        {
          name: 'web-voucher.index',
          path: 'web-voucher',
          component: PassThrough,
          children: [
            {
              name: 'promotion-channel.web-voucher',
              path: ':id',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.voucher')} Channel`,
                authRequired: true,
                key: 'web-voucher-:id',
              },
              component: () =>
                import('@/views/web-platform-channel/promotion/voucher'),
              children: [
                {
                  path: 'detail-voucher',
                  name: 'discounts.view',
                  meta: {
                    title: `Powerbiz - ${i18n.t(
                      'sideBar.voucherdetail',
                    )} Channel`,
                    authRequired: true,
                    key: 'web-voucher-:id',
                  },
                  component: () =>
                    import(
                      '@/views/web-platform-channel/promotion/voucher/detail'
                    ),
                },
              ],
            },
            {
              path: ':id/add-voucher',
              name: 'add-voucher',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.addvoucher')} Channel`,
                authRequired: true,
                key: 'web-voucher-:id',
              },
              component: () =>
                import('@/views/web-platform-channel/promotion/voucher/create'),
            },
            {
              path: ':id/edit-voucher',
              name: 'edit-voucher',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.editvoucher')} Channel`,
                authRequired: true,
                key: 'web-voucher-:id',
              },
              component: () =>
                import('@/views/web-platform-channel/promotion/voucher/edit'),
            },
          ],
        },

        {
          name: 'web-store-setting',
          path: 'web-store-setting',
          component: PassThrough,
          children: [
            {
              name: 'web-store-setting.id',
              path: ':id',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.storesetting')} Channel`,
                authRequired: true,
                key: 'web-store-setting-:id',
              },
              component: () =>
                import('@/views/web-platform-channel/store-settings'),
            },
          ],
        },



        {
          path: 'integration',
          component: PassThrough,
          name: 'integration',
          children: [
            {
              path: '/integration/tiktok',
              name: 'integration.tiktok',
              redirect: to => {
                if (to.query.code) {
                  const pathCallback = JSON.parse(
                    localStorage.getItem('pathCallback'),
                  )
                  pathCallback.query.code = to.query.code
                  localStorage.setItem(
                    'pathCallback',
                    JSON.stringify(pathCallback),
                  )
                }
                if (typeof localStorage.getItem('pathCallback') === 'string') {
                  return {
                    ...JSON.parse(localStorage.getItem('pathCallback')),
                    query: {
                      ...JSON.parse(localStorage.getItem('pathCallback')).query,
                      code: to.query.code,
                      app_key: to.query.app_key,
                    },
                  }
                } else {
                  return '/dashboard'
                }
              },
            },
            {
              path: '/integration/shopee',
              name: 'integration.shopee',
              redirect: to => {
                if (to.query.code) {
                  const pathCallback = JSON.parse(
                    localStorage.getItem('pathCallback'),
                  )
                  pathCallback.query.code = to.query.code
                  pathCallback.query.shop_id = to.query.shop_id
                  localStorage.setItem(
                    'pathCallback',
                    JSON.stringify(pathCallback),
                  )
                }
                if (typeof localStorage.getItem('pathCallback') === 'string') {
                  return {
                    ...JSON.parse(localStorage.getItem('pathCallback')),
                    query: {
                      ...JSON.parse(localStorage.getItem('pathCallback')).query,
                      code: to.query.code,
                      shop_id: to.query.shop_id,
                    },
                  }
                } else {
                  return '/dashboard'
                }
              },
            },
            {
              path: '/integration/toco',
              name: 'integration.toco',
              redirect: to => {
                const storedCallback = localStorage.getItem('pathCallback')
                if (typeof storedCallback !== 'string') {
                  return '/dashboard'
                }

                let pathCallback
                try {
                  pathCallback = JSON.parse(storedCallback)
                } catch (error) {
                  localStorage.removeItem('pathCallback')
                  return '/dashboard'
                }

                const query = {
                  ...pathCallback.query,
                  sid: to.query.sid,
                  storeAccess: to.query.storeAccess,
                }
                pathCallback.query = query
                localStorage.setItem('pathCallback', JSON.stringify(pathCallback))

                return {
                  ...pathCallback,
                  query,
                }
              },
            },
            {
              path: '/reauthorize/shopee',
              name: 'reauthorize.shopee',
              redirect: to => {
                if (to.query.code) {
                  const pathCallback = JSON.parse(
                    localStorage.getItem('pathCallback'),
                  )
                  pathCallback.query.code = to.query.code
                  pathCallback.query.shop_id = to.query.shop_id
                  localStorage.setItem(
                    'pathCallback',
                    JSON.stringify(pathCallback),
                  )
                }
                if (typeof localStorage.getItem('pathCallback') === 'string') {
                  return {
                    ...JSON.parse(localStorage.getItem('pathCallback')),
                    query: {
                      ...JSON.parse(localStorage.getItem('pathCallback')).query,
                      code: to.query.code,
                      shop_id: to.query.shop_id,
                    },
                  }
                } else {
                  return '/store'
                }
              },
            },
            {
              path: '/integration/lazada/callback',
              name: 'integration.lazada',
              redirect: to => {
                if (to.query.code) {
                  const pathCallback = JSON.parse(
                    localStorage.getItem('pathCallback'),
                  )
                  pathCallback.query.code = to.query.code
                  localStorage.setItem(
                    'pathCallback',
                    JSON.stringify(pathCallback),
                  )
                }
                if (typeof localStorage.getItem('pathCallback') === 'string') {
                  return {
                    ...JSON.parse(localStorage.getItem('pathCallback')),
                    query: {
                      ...JSON.parse(localStorage.getItem('pathCallback')).query,
                      code: to.query.code,
                    },
                  }
                } else {
                  return '/dashboard'
                }
              },
            },
          ],
        },


        {
          path: 'product',
          component: PassThrough,
          name: 'product',
          children: [
            {
              path: '/product',
              name: 'product.master',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.product_master')}`,
                key: 'product-master',
                authRequired: true,
              },
              component: () => import('@/views/products/index-v2.vue'),
            },
            {
              path: '/product-category',
              name: 'product.category',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.productCategory')}`,
                key: 'product-category',
                authRequired: true,
              },
              component: () => import('@/views/category/index.vue'),
            },
            {
              path: '/product/create',
              name: 'product.create',
              meta: {
                title: i18n.t('pageTitles.addProductMaster'),
                key: 'create-product',
                authRequired: true,
              },
              component: () => import('@/views/products/create-v2'),
            },
            {
              path: '/product/edit',
              name: 'product.edit',
              meta: {
                title: i18n.t('pageTitles.editProductMaster'),
                key: 'edit-product',
              },
              component: () => import('@/views/products/edit'),
            },
            {
              path: '/product/import',
              name: 'product.import',
              meta: {
                title: i18n.t('pageTitles.importProductMaster'),
                key: 'import-product',
              },
              component: () => import('@/views/products/import'),
            },
            {
              path: '/product/allocation',
              name: 'product.allocation.old',
              meta: {
                title: i18n.t('pageTitles.stockAllocation'),
                key: 'allocation-product',
              },
              component: () => import('@/views/products/allocation'),
            },
            {
              path: '/product/:id/allocation',
              name: 'product.allocation',
              meta: {
                title: i18n.t('pageTitles.stockAllocation'),
                key: 'allocation-product',
                authRequired: true,
              },
              component: () => import('@/views/products/allocations'),
            },
            {
              path: '/product/bulk-publish',
              name: 'product.bulk-publish',
              meta: {
                title: i18n.t('pageTitles.bulkPublishProduct'),
                key: 'import-product',
              },
              component: () => import('@/views/products/bulk-publish'),
            },
          ],
        },


        {
          path: '/product-channel',
          component: PassThrough,
          name: 'product-channel',
          children: [
            {
              path: ':id',
              component: () => import('@/views/store/[id].vue'),
              children: [
                {
                  path: 'product/synchronize',
                  name: 'product-channel.product-list',
                  meta: {
                    title: `Powerbiz - ${i18n.t('sideBar.product_list')}`,
                    key: 'product-list-:id',
                    authRequired: true,
                  },
                  component: () =>
                    import('@/views/store/[id]/product/synchronize/index.vue'),
                },
                {
                  path: 'product/synchronize/create-product-tokopedia',
                  name: 'product.channel.tokopedia_id',
                  meta: {
                    title: i18n.t('pageTitles.addProductTokopedia'),
                    key: 'create-product-tokopedia',
                    authRequired: true,
                  },
                  component: () =>
                    import(
                      '@/views/store/[id]/product/synchronize/tokopedia/create.vue'
                    ),
                },
                {
                  path: 'product/synchronize/create-product-tiktok',
                  name: 'product.channel.create',
                  meta: {
                    title: i18n.t('pageTitles.addProductChannel'),
                    key: 'create-product-channel',
                    authRequired: true,
                  },
                  component: () =>
                    import(
                      '@/views/store/[id]/product/synchronize/tiktok/create.vue'
                    ),
                },
                {
                  path: 'product/synchronize/create-product-shopee',
                  name: 'product.channel.shopee_id',
                  meta: {
                    title: i18n.t('pageTitles.addProductChannel'),
                    key: 'create-product-channel-shopee',
                    authRequired: true,
                  },
                  component: () =>
                    import(
                      '@/views/store/[id]/product/synchronize/shopee/create.vue'
                    ),
                },
                {
                  path: 'product/synchronize/create-product-blibli',
                  name: 'product.channel.blibli_id',
                  meta: {
                    title: i18n.t('pageTitles.addProductChannel'),
                    key: 'create-product-channel-blibli',
                    authRequired: true,
                  },
                  component: () =>
                    import(
                      '@/views/store/[id]/product/synchronize/blibli/create.vue'
                    ),
                },
                {
                  path: 'product/synchronize/create-product-distributor',
                  name: 'product.channel.distributor',
                  meta: {
                    title: i18n.t('pageTitles.addProductChannel'),
                    key: 'create-product-channel',
                    authRequired: true,
                  },
                  component: () =>
                    import(
                      '@/views/store/[id]/product/synchronize/distributor/create.vue'
                    ),
                },
                {
                  path: 'product/synchronize/create-product-toco',
                  name: 'product.channel.toco_id',
                  meta: {
                    title: i18n.t('pageTitles.addProductChannel'),
                    key: 'create-product-channel-toco',
                    authRequired: true,
                  },
                  component: () =>
                    import(
                      '@/views/store/[id]/product/synchronize/toco/create.vue'
                    ),
                },
                {
                  path: 'product/edit-product-tiktok',
                  name: 'product-channel.product-synchronize-edit',
                  meta: {
                    title: `Powerbiz - ${i18n.t('sideBar.product_list')}`,
                    key: 'product-list-:id',
                    authRequired: true,
                  },
                  component: () =>
                    import(
                      '@/views/store/[id]/product/synchronize/tiktok/edit.vue'
                    ),
                },
                {
                  path: 'product/edit-product-tokopedia',
                  name: 'product-channel.product-synchronize-edit-tokped',
                  meta: {
                    title: `Powerbiz - ${i18n.t('sideBar.product_list')}`,
                    key: 'product-list-:id',
                    authRequired: true,
                  },
                  component: () =>
                    import(
                      '@/views/store/[id]/product/synchronize/tokopedia/edit.vue'
                    ),
                },
                {
                  path: 'product/edit-product-shopee',
                  name: 'product-channel.product-synchronize-edit-shopee',
                  meta: {
                    title: `Powerbiz - ${i18n.t('sideBar.product_list')}`,
                    key: 'product-list-:id',
                    authRequired: true,
                  },
                  component: () =>
                    import(
                      '@/views/store/[id]/product/synchronize/shopee/edit.vue'
                    ),
                },
                {
                  path: 'product/edit-product-blibli',
                  name: 'product-channel.product-synchronize-edit-blibli',
                  meta: {
                    title: `Powerbiz - ${i18n.t('sideBar.product_list')}`,
                    key: 'product-list-:id',
                    authRequired: true,
                  },
                  component: () =>
                    import(
                      '@/views/store/[id]/product/synchronize/blibli/edit.vue'
                    ),
                },
                {
                  path: 'product/edit-product-lazada',
                  name: 'product-channel.product-synchronize-edit-lazada',
                  meta: {
                    title: `Powerbiz - ${i18n.t('sideBar.product_list')}`,
                    key: 'product-list-:id',
                    authRequired: true,
                  },
                  component: () =>
                    import(
                      '@/views/store/[id]/product/synchronize/lazada/edit.vue'
                    ),
                },
                {
                  path: 'product/edit-product-distributor',
                  name: 'product-channel.distributor-product-synchronize-edit',
                  meta: {
                    title: `Powerbiz - ${i18n.t('sideBar.product_list')}`,
                    key: 'product-list-:id',
                    authRequired: true,
                  },
                  component: () =>
                    import(
                      '@/views/store/[id]/product/synchronize/distributor/edit.vue'
                    ),
                },
                {
                  path: 'product/edit-product-toco',
                  name: 'product-channel.product-synchronize-edit-toco',
                  meta: {
                    title: `Powerbiz - ${i18n.t('sideBar.product_list')}`,
                    key: 'product-list-:id',
                    authRequired: true,
                  },
                  component: () =>
                    import(
                      '@/views/store/[id]/product/synchronize/toco/edit.vue'
                    ),
                },
                {
                  path: 'price-area',
                  name: 'product-channel.price-area',
                  meta: {
                    title: `Powerbiz - ${i18n.t('sideBar.product_list')}`,
                    key: 'price-area-:id',
                    authRequired: true,
                  },
                  component: () => import('@/views/store/price-area/index.vue'),
                },
                {
                  path: 'setup-product-tags',
                  name: 'product-channel.setup-product-tags',
                  meta: {
                    title: `Powerbiz - Setup Tag Produk`,
                    key: 'setup-product-tags-:id',
                    authRequired: true,
                  },
                  component: () => import('@/views/store/setup-product-tags/index.vue'),
                },
                {
                  path: 'manage-product-tags',
                  name: 'product-channel.manage-product-tags',
                  meta: {
                    title: `Powerbiz - Kelola Produk Tag`,
                    key: 'manage-product-tags',
                    authRequired: true,
                  },
                  component: () => import('@/views/store/manage-product-tags/index.vue'),
                },
              ],
            },
          ],
        },


        {
          path: 'price',
          component: PassThrough,
          name: 'price',
          children: [
            {
              path: '/price',
              name: 'price-setting',
              meta: {
                title: i18n.t('pageTitles.priceSetting'),
                key: 'price-setting',
                authRequired: true,
              },
              component: () => import('@/views/price/formula-variable'),
            },
            {
              path: '/formula-variable',
              name: 'formula variable',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.formula_variable')}`,
                key: 'formula-variable',
                authRequired: true,
              },
              component: () => import('@/views/price/formula-variable'),
            },
            {
              path: '/formula-variable/add',
              name: 'formula variable.add',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.formula_variable')}`,
                key: 'add-formula-variable',
                authRequired: true,
              },
              component: () => import('@/views/price/formula-variable/add'),
            },
            {
              path: '/formula-variable/edit/:id',
              name: 'formula variable.edit',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.formula_variable')}`,
                key: 'edit-formula-variable',
                authRequired: true,
              },
              component: () => import('@/views/price/formula-variable/edit'),
            },
            {
              path: '/global-variable',
              name: 'global variable',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.global_variable')}`,
                key: 'global-variable',
                authRequired: true,
              },
              component: () => import('@/views/price/global-variable'),
            },
            {
              path: '/global-variable/add',
              name: 'global variable.add',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.global_variable')}`,
                key: 'add-global-variable',
                authRequired: true,
              },
              component: () => import('@/views/price/global-variable/add'),
            },
            {
              path: '/global-variable/edit/:id',
              name: 'global variable.edit',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.global_variable')}`,
                key: 'edit-global-variable',
                authRequired: true,
              },
              component: () => import('@/views/price/global-variable/edit'),
            },
            {
              path: '/price-formula',
              name: 'price formula',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.price_formula')}`,
                key: 'price-formula',
                authRequired: true,
              },
              component: () => import('@/views/price/price-formula'),
            },
            {
              path: '/price-formula/add',
              name: 'price-formula.add',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.price_formula')}`,
                key: 'add-price-formula',
                authRequired: true,
              },
              component: () => import('@/views/price/price-formula/add'),
            },
            {
              path: '/price-formula/edit/:id',
              name: 'price-formula.edit',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.price_formula')}`,
                key: 'edit-price-formula',
                authRequired: true,
              },
              component: () => import('@/views/price/price-formula/edit'),
            },
            {
              path: '/product-variable',
              name: 'product variable',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.product_variable')}`,
                key: 'product-variable',
                authRequired: true,
              },
              component: () => import('@/views/price/product-variable'),
            },
            {
              path: '/product-variable/add',
              name: 'product variable.add',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.product_variable')}`,
                key: 'add-product-variable',
                authRequired: true,
              },
              component: () => import('@/views/price/product-variable/add'),
            },
            {
              path: '/product-variable/edit/:id',
              name: 'product variable.edit',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.product_variable')}`,
                key: 'edit-product-variable',
                authRequired: true,
              },
              component: () => import('@/views/price/product-variable/edit'),
            },
          ],
        },


        {
          path: '',
          component: PassThrough,
          name: 'inventory',
          children: [
            {
              path: '/inventory/stock-alocation',
              name: 'inventory.stock.alocation',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.inventory_list')}`,
                key: 'stock-alocation',
                authRequired: true,
              },
              component: () => import('@/views/inventory/productavailability'),
            },
            {
              path: '/inventory/goods-receipt',
              name: 'inventory.goods.receipt',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.inventory_list')}`,
                key: 'goods-receipt',
                authRequired: true,
              },
              component: () => import('@/views/inventory/goods-receipt'),
            },
            {
              path: '/inventory/goods-receipt/create',
              name: 'inventory.goods.receipt.create',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.inventory_list')}`,
                key: 'goods-receipt-create',
                authRequired: true,
              },
              component: () => import('@/views/inventory/goods-receipt/create'),
            },
            {
              path: '/inventory/goods-receipt/detail/:id',
              name: 'inventory.goods.receipt.detail',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.inventory_list')}`,
                key: 'goods-receipt-detail',
                authRequired: true,
              },
              component: () => import('@/views/inventory/goods-receipt/detail'),
            },
            {
              path: '/inventory/return-received',
              name: 'inventory.return.received',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.inventory_list')}`,
                key: 'return-received',
                authRequired: true,
              },
              component: () => import('@/views/inventory/return-received'),
            },
            {
              path: '/inventory/return-received/create',
              name: 'inventory.return.received.create',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.inventory_list')}`,
                key: 'return-received-create',
                authRequired: true,
              },
              component: () => import('@/views/inventory/return-received/create'),
            },
            {
              path: '/inventory/stock-adjustment',
              name: 'inventory.stock.adjustment',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.inventory_list')}`,
                key: 'stock-adjustment',
                authRequired: true,
              },
              component: () => import('@/views/inventory/stockAdjustment'),
            },
            {
              path: '/inventory/stock-adjustment/create',
              name: 'inventory.stock.adjustment.create',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.inventory_list')}`,
                key: 'stock-adjustment-create',
                authRequired: true,
              },
              component: () => import('@/views/inventory/stockAdjustment/create/create.vue'),
            },
            {
              path: '/inventory/stock-adjustment/detail/:id',
              name: 'inventory.stock.adjustment.detail',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.inventory_list')}`,
                key: 'stock-adjustment-detail',
                authRequired: true,
              },
              component: () => import('@/views/inventory/stockAdjustment/detail'),
            },
            {
              path: '/inventory/list-inventoryv2',
              name: 'inventory.list.inventory.v2',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.inventory_list')}`,
                key: 'list-inventoryv2',
                authRequired: true,
              },
              component: () => import('@/views/inventory/inventory-v2'),
            },
            {
              path: '/inventory/list-inventoryv2/import-reserved-stock',
              name: 'inventory.list.inventory.v2.import',
              meta: {
                title: `Powerbiz - Import Reserved Stock`,
                key: 'list-inventoryv2',
                authRequired: true,
              },
              component: () => import('@/views/inventory/inventory-v2/import-reserved-stock.vue'),
            },
            {
              path: '/inventory/movement/:id',
              name: 'inventory.detail.stock.movement',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.inventory_movement')}`,
                key: 'list-inventoryv2',
                authRequired: true,
              },
              component: () => import('@/views/inventory/inventory-v2/detail-stock-movement'),
            },
            {
              path: '/inventory/inbound',
              name: 'inventory.inbound',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.inventory_list')}`,
                key: 'inbound',
                authRequired: true,
              },
              component: () => import('@/views/inventory/inbound'),
            },
            {
              path: '/inventory/stock-movement',
              name: 'inventory.stock.movement',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.inventory_list')}`,
                key: 'inventory-stock-movement',
                authRequired: true,
              },
              component: () => import('@/views/inventory/stock-movement'),
            },
            {
              path: '/inventory/transfer-stock',
              name: 'inventory.transfer.stock',
              meta: {
                title: `Powerbiz - ${i18n.t('transferStock.title')}`,
                key: 'inventory-transfer-stock',
                authRequired: true,
              },
              component: () => import('@/views/inventory/transfer-stock/index.vue'),
            },
            {
              path: '/inventory/transfer-stock/create',
              name: 'inventory.transfer.stock.create',
              meta: {
                title: `Powerbiz - ${i18n.t('transferStock.createTitle')}`,
                key: 'inventory-transfer-stock',
                authRequired: true,
              },
              component: () => import('@/views/inventory/transfer-stock/create.vue'),
            },
            {
              path: '/inventory/transfer-stock/import',
              name: 'inventory.transfer.stock.import',
              meta: {
                title: `Powerbiz - ${i18n.t('transferStock.buttons.importTitle')}`,
                key: 'inventory-transfer-stock',
                authRequired: true,
              },
              component: () => import('@/views/inventory/transfer-stock/import.vue'),
            },
            {
              path: '/inventory/transfer-stock/:id',
              name: 'inventory.transfer.stock.detail',
              meta: {
                title: `Powerbiz - ${i18n.t('transferStock.detailTitle')}`,
                key: 'inventory-transfer-stock',
                authRequired: true,
              },
              component: () => import('@/views/inventory/transfer-stock/detail.vue'),
            },
          ],
        },


        {
          path: '/finance-channel',
          component: PassThrough,
          name: 'finance-channel',
          children: [
            {
              path: ':id/withdrawal',
              name: 'finance-channel.withdrawal',
              meta: {
                title: i18n.t('pageTitles.withdrawal'),
                key: 'withdrawal-:id',
                authRequired: true,
              },
              component: () => import('@/views/finance/withdrawl/index.vue'),
            },
            {
              path: ':id/wallet/history',
              name: 'finance-channel.wallet.history',
              meta: {
                title: i18n.t('pageTitles.walletHistory'),
                key: 'withdrawal-:id',
                authRequired: true,
              },
              component: () => import('@/views/finance/history-wallet/index.vue'),
            },
            {
              path: ':id/wallet-withdrawl',
              name: 'distributor-channel.wallet-withdrawl',
              meta: {
                title: i18n.t('pageTitles.walletWithdrawal'),
                key: 'withdrawal-:id',
                authRequired: true,
              },
              component: () =>
                import('@/views/finance/withdrawl/walletWithdrawl'),
            },
            {
              path: ':id/payment-channel',
              name: 'finance-channel.payment-channel',
              meta: {
                title: i18n.t('pageTitles.payment'),
                key: 'payment-channel-:id',
                authRequired: true,
              },
              component: () =>
                import('@/views/finance/payment-channel/index.vue'),
            },
            {
              path: ':id/payment-history',
              name: 'finance-channel.payment-history',
              meta: {
                title: i18n.t('pageTitles.paymentHistory'),
                key: 'payment-history-:id',
                authRequired: true,
              },
              component: () =>
                import('@/views/finance/payment-history/index.vue'),
            },
            {
              path: ':id/invoice',
              name: 'finance-channel.invoice',
              meta: {
                title: i18n.t('pageTitles.invoice'),
                key: 'invoice-:id',
                authRequired: true,
              },
              component: () =>
                import('@/views/finance/invoice-channel/index.vue'),
            },
            {
              path: ':id/invoice-detail',
              name: 'finance-channel.invoice-detail',
              meta: {
                title: i18n.t('pageTitles.invoice'),
                key: 'invoice-:id',
                authRequired: true,
              },
              component: () =>
                import(
                  '@/views/finance/invoice-channel/partials/DetailInvoice.vue'
                ),
            },
            {
              path: ':id/credit-notes',
              name: 'finance-channel.credit-notes',
              meta: {
                title: i18n.t('pageTitles.creditNotes'),
                key: 'credit-notes-:id',
                authRequired: true,
              },
              component: () => import('@/views/finance/credit-notes/index.vue'),
            },
          ],
        },


        {
          path: '/promotion-channel',
          component: PassThrough,
          name: 'promotion-channel',
          children: [
            {
              path: ':id/discount',
              name: 'promotion-channel.discount',
              meta: {
                title: i18n.t('pageTitles.productDiscount'),
                key: 'discount-:id',
                authRequired: true,
              },
              component: () => import('@/views/promotion/product-discount'),
            },
            {
              path: ':id/discount/add',
              name: 'promotion-channel.discount.add',
              meta: {
                title: i18n.t('pageTitles.addDiscount'),
                key: 'discount-:id',
                authRequired: true,
              },
              component: () =>
                import('@/views/promotion/product-discount/create'),
            },
            {
              path: ':id/voucher',
              name: 'promotion-channel.voucher',
              meta: {
                title: i18n.t('pageTitles.voucher'),
                key: 'voucher-:id',
                authRequired: true,
              },
              component: () => import('@/views/promotion/voucher/index.vue'),
            },
            {
              path: ':id/voucher/add',
              name: 'promotion-channel.voucher.add',
              meta: {
                title: i18n.t('pageTitles.addVoucher'),
                key: 'voucher-:id',
                authRequired: true,
              },
              component: () => import('@/views/promotion/voucher/create.vue'),
            },
            {
              path: ':id/approval',
              name: 'promotion-channel.approval',
              meta: {
                title: i18n.t('pageTitles.approval'),
                key: 'approval-:id',
                authRequired: true,
              },
              component: () => import('@/views/promotion/approval'),
            },
          ],
        },


        {
          path: '/customer-channel',
          component: PassThrough,
          name: 'customer-channel',
          children: [
            {
              path: ':id/customer-list',
              name: 'customer-channel.customer-list',
              meta: {
                title: i18n.t('pageTitles.customer'),
                key: 'customer-list-:id',
                authRequired: true,
              },
              component: () => import('@/views/customer-channel/index.vue'),
            },
            {
              path: ':id/customer-list/form',
              name: 'customer-channel.customer-list.form',
              meta: {
                title: i18n.t('pageTitles.formCustomer'),
                key: 'customer-list-:id',
                authRequired: true,
              },
              component: () => import('@/components/InviteCustomer/index.vue'),
            },
            {
              path: ':id/customer-list-v2',
              name: 'customer-channel.customer-list-v2',
              meta: {
                title: i18n.t('pageTitles.customer'),
                key: 'customer-list-v2-:id',
                authRequired: true,
              },
              component: () => import('@/views/customer-channel/index.vue'),
            },
            {
              path: ':id/customer-list-v2/form',
              name: 'customer-channel.customer-list-v2.form',
              meta: {
                title: i18n.t('pageTitles.formCustomer'),
                key: 'customer-list-v2-:id',
                authRequired: true,
              },
              component: () => import('@/components/InviteCustomerV2/index.vue'),
            },
            {
              path: ':id/customer-category',
              name: 'customer-channel.customer-category',
              meta: {
                title: i18n.t('pageTitles.customer'),
                key: 'customer-category-:id',
                authRequired: true,
              },
              component: () => import('@/views/customer-channel/customer-category/index.vue'),
            },
          ],
        },


        {
          path: '/user-management',
          component: PassThrough,
          name: 'User Management',
          children: [
            {
              path: '/user-management',
              name: 'user-management',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.user')}`,
                key: 'user-management',
                authRequired: true,
              },
              component: () =>
                import('@/views/setting/userManagement/index.vue'),
            },
            {
              path: '/user-management/invite-user',
              name: 'invite-user',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.user')}`,
                key: 'invite-user',
                authRequired: true,
              },
              component: () => import('@/components/InviteUser/index.vue'),
            },
            {
              path: '/user-management/edit-user',
              name: 'edit-user',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.user')}`,
                key: 'edit-user',
                authRequired: true,
              },
              component: () => import('@/components/InviteUser/index.vue'),
            },
          ],
        },


        {
          path: '/store-list',
          component: PassThrough,

          children: [
            {
              path: '/',
              name: 'store-list',
              meta: {
                title: i18n.t('pageTitles.storeList'),
                key: 'store-list',
                authRequired: true,
              },
              redirect: {
                name: 'store.list',
              },
            },
          ],
        },


        {
          path: '/add-store',
          component: PassThrough,

          children: [
            {
              path: '/',
              name: 'add-store',
              meta: {
                title: i18n.t('pageTitles.addStore'),
                key: 'add-store',
                authRequired: true,
              },
              component: () => import('@/views/store/add-store/index.vue'),
            },
          ],
        },


        {
          path: '/store',
          name: 'store',
          component: PassThrough,
          children: [
            {
              path: '/store',
              name: 'store.list',
              meta: {
                title: i18n.t('pageTitles.storeList'),
                key: 'store-list',
                authRequired: true,
              },
              component: () => import('@/views/store/index.vue'),
            },
            {
              path: '/admin-store',
              name: 'admin.store',
              meta: {
                title: i18n.t('pageTitles.confirmStore'),
                key: 'admin-store',
                authRequired: true,
              },
              component: () => import('@/views/store/admin-store'),
            },
            {
              path: ':id',
              component: () => import('@/views/store/[id].vue'),
              children: [
                {
                  path: 'product/synchronize',
                  name: 'store.product-synchronize',
                  meta: {
                    title: 'Powerbiz - ',
                    key: 'product.synchronize',
                    authRequired: true,
                  },
                  component: () =>
                    import('@/views/store/[id]/product/synchronize/index.vue'),
                },
              ],
            },
          ],
        },





































































        {
          path: '/integration',
          component: PassThrough,
          name: 'integrations',
          children: [
            {
              path: '/integration',
              name: 'integration.list',
              meta: {
                title: i18n.t('pageTitles.integration'),
                key: 'integration',
              },
              component: () => import('@/views/integration/list/index.vue'),
            },
            {
              path: '/integration/list',
              name: 'integration.list.channel',
              meta: {
                title: i18n.t('pageTitles.integrationListChannel'),
                key: 'integration-list-channel',
              },
              component: () => import('@/views/integration/list'),
            },
          ],
        },





















































        {
          path: '/warehouse',
          component: PassThrough,
          name: 'warehouse',
          children: [
            {
              path: '/warehouse',
              name: 'warehouse-list',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.warehouse')}`,
                key: 'warehouse',
                authRequired: true,
              },
              component: () => import('@/views/setting/warehouse/index.vue'),
            },
            {
              path: '/warehouse/add-warehouse',
              name: 'warehouse-add',
              meta: {
                title: `Powerbiz - ${i18n.t('warehouse.add_warehouse')}`,
                key: 'warehouse',
                authRequired: true,
              },
              component: () => import('@/views/setting/warehouse/add.vue'),
            },
            {
              path: '/warehouse/update-warehouse/:id',
              name: 'warehouse-update',
              meta: {
                title: `Powerbiz - ${i18n.t('warehouse.update_warehouse')}`,
                key: 'warehouse',
                authRequired: true,
              },
              component: () => import('@/views/setting/warehouse/add.vue'),
            },
          ],
        },


        {
          path: '/account-setting',
          component: PassThrough,
          name: 'account-setting',
          children: [
            {
              path: '/account-setting',
              name: 'account-setting-list',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.account')}`,
                key: 'account-setting',
                authRequired: true,
              },
              component: () =>
                import('@/views/setting/accountSetting/index.vue'),
            },
          ],
        },


        {
          path: 'export-history',
          component: PassThrough,
          name: 'export-history',
          children: [
            {
              path: '/export-history',
              name: 'export-history.index',
              meta: {
                title: `Powerbiz - ${i18n.t('sideBar.export_history')}`,
                key: 'export-history',
                authRequired: true,
              },
              component: () => import('@/views/export/index.vue'),
            },
          ],
        },


        {
          path: '/redeem-channel',
          component: PassThrough,
          name: 'redeem-channel:id',
          children: [
            {
              path: ':id/redeem-product-channel',
              name: 'redeem-channel.redeem-product-channel',
              meta: {
                title: i18n.t('pageTitles.redeemProduct'),
                key: 'redeem-product-channel-:id',
                authRequired: true,
              },
              component: () => import('@/views/redeem-channel/product.vue'),
            },
            {
              path: ':id/redeem-product-channel-edit',
              name: 'redeem-channel.redeem-product-channel-edit',
              meta: {
                title: i18n.t('pageTitles.redeemProduct'),
                key: 'redeem-product-channel-:id',
                authRequired: true,
              },
              component: () => import('@/views/redeem-channel/edit.vue'),
            },
            {
              path: ':id/redeem-product-channel/create',
              name: 'redeem-channel.create-new-redeem-product-channel',
              meta: {
                title: i18n.t('pageTitles.addProductRedeem'),
                key: 'create-new-redeem-product-channel-:id',
                authRequired: true,
              },
              component: () => import('@/views/products/create'),
            },
            {
              path: ':id/redeem-product-channel/edit',
              name: 'redeem-channel.edit-new-redeem-product-channel',
              meta: {
                title: i18n.t('pageTitles.editProductRedeem'),
                key: 'edit-new-redeem-product-channel-:id',
              },
              component: () => import('@/views/products/edit'),
            },
            {
              path: ':id/redeem-sales-channel',
              name: 'redeem-channel.redeem-sales-channel',
              meta: {
                title: i18n.t('pageTitles.redeemSales'),
                key: 'redeem-sales-channel-:id',
                authRequired: true,
              },
              component: () => {
                return import('@/views/sales/index.vue')
              },
            },
          ],
        },

        {
          path: '/redeem-product-channel',
          component: PassThrough,
          name: 'redeem-product-channel:id',
          children: [
            {
              path: ':id/redeem-product-list',
              name: 'redeem-product-channel.redeem-product-list',
              meta: {
                title: i18n.t('pageTitles.redeemProduct'),
                key: 'redeem-product-list-:id',
                authRequired: true,
              },
              component: () => import('@/views/redeem-channel/product.vue'),
            },
          ],
        },


        {
          path: '/distributor-channel',
          component: PassThrough,
          name: 'distributor-channel:id',
          children: [
            {
              path: ':id/distributor-list',
              name: 'distributor-channel.distributor-list',
              meta: {
                title: i18n.t('pageTitles.distributor'),
                key: 'distributor-list-:id',
                authRequired: true,
              },
              component: () =>
                import('@/views/distributor-channel/ListDistributor'),
            },
            {
              path: ':id/add-distributor',
              name: 'distributor-channel.add-distributor',
              meta: {
                title: i18n.t('pageTitles.addDistributor'),
                key: 'distributor-list-:id',
                authRequired: true,
              },
              component: () =>
                import('@/views/distributor-channel/AddDistributor'),
            },
          ],
        },


        {
          path: '/retur-channel',
          component: PassThrough,
          name: 'retur-channel',
          children: [
            {
              path: ':id/submission',
              name: 'retur-channel.submission',
              meta: {
                title: i18n.t('pageTitles.submission'),
                key: 'retur-submission-:id',
                authRequired: true,
              },
              component: () =>
                import('@/views/retur-channel/submission/index.vue'),
            },
            {
              path: ':id/retur-list',
              name: 'retur-channel.retur-list',
              meta: {
                title: i18n.t('pageTitles.retur'),
                key: 'retur-list-:id',
                authRequired: true,
              },
              component: () => import('@/views/retur-channel/list/index.vue'),
            },
            {
              path: ':id/retur-request-list',
              name: 'retur-channel.retur-request-list',
              meta: {
                title: i18n.t('pageTitles.retur'),
                key: 'retur-request-list-:id',
                authRequired: true,
              },
              component: () => import('@/views/retur-channel/list/index.vue'),
            },
          ],
        },


        {
          path: '/web-management',
          component: PassThrough,
          name: 'web-management',
          children: [
            {
              path: ':id/web-store-setting',
              name: 'web-management.web-store-setting',
              meta: {
                title: i18n.t('pageTitles.banner'),
                key: 'web-store-setting-:id',
                authRequired: true,
              },
              component: () => import('@/views/web-platform-channel/store-settings'),
            },
            {
              path: ':id/cms-manage',
              name: 'web-management.cms-manage',
              meta: {
                title: i18n.t('pageTitles.banner'),
                key: 'cms-manage-:id',
                authRequired: true,
              },
              component: () => import('@/views/web-platform-channel/store-settings/RedirectExternal.vue'),
            },
          ],
        },



        {
          path: '/purchase-order',
          component: PassThrough,
          name: 'purchase-order',
          children: [
            {
              path: 'list',
              name: 'purchase-order.list',
              meta: {
                title: i18n.t('pageTitles.purchaseOrder'),
                key: 'purchase-order-:id',
                authRequired: true,
              },
              component: () => import('@/views/purchase-order/index.vue'),
            },
            {
              path: 'create',
              name: 'purchase-order.create',
              meta: {
                title: i18n.t('pageTitles.createPurchaseOrder'),
                key: 'purchase-order-:id-create',
                authRequired: true,
              },
              component: () => import('@/views/purchase-order/create/index.vue'),
            },
          ],
        },


        {
          path: '/supplier',
          component: PassThrough,
          name: 'supplier',
          children: [
            {
              path: 'list',
              name: 'supplier.list',
              meta: {
                title: i18n.t('pageTitles.supplier'),
                key: 'supplier-:id',
                authRequired: true,
              },
              component: () => import('@/views/supplier/index.vue'),
            },
          ],
        },


        {
          path: '/error',
          component: PassThrough,
          name: 'error-page',
          children: [
            {
              path: '404',
              name: 'error404',
              meta: {
                title: i18n.t('pageTitles.error404'),
                authRequired: true,
              },
              component: () => import('@/views/errors/404.vue'),
            },
            {
              path: '403',
              name: 'error403',
              meta: {
                title: i18n.t('pageTitles.error403'),
                authRequired: true,
              },
              component: () => import('@/views/errors/403.vue'),
            },
          ],
        },
      ],
    },


    {
      path: '/auth',
      meta: {
        title: 'Powerbiz - Powerbiz',
      },
      component: AuthLayout,
      redirect: 'auth/login',
      children: [
        {
          path: '/auth/404',
          meta: {
            title: 'Powerbiz - Error 404',
          },
          component: () => import('./views/auth/404'),
        },
        {
          path: '/auth/403',
          meta: {
            title: 'Powerbiz - Error 403',
          },
          component: () => import('./views/auth/403'),
        },
        {
          path: '/auth/500',
          meta: {
            title: i18n.t('pageTitles.error500'),
          },
          component: () => import('./views/auth/500'),
        },
        {
          path: '/auth/register/link-expired',
          meta: {
            title: i18n.t('pageTitles.linkExpired'),
          },
          component: () => import('@/views/auth/link-expired'),
        },
        {
          name: 'LoginPage',
          path: '/auth/login',
          meta: {
            title: i18n.t('pageTitles.signIn'),
          },
          component: () => import('./views/auth/login'),
        },
        {
          path: '/auth/forgot-password',
          meta: {
            title: i18n.t('pageTitles.forgotPassword'),
            authRequired: false,
          },
          component: () => import('./views/auth/forgot-password'),
        },
        {
          path: '/auth/forgot-password/otp',
          meta: {
            title: 'Powerbiz - Lupa Kata Sandi',
          },
          component: () => import('@/views/auth/forgot-password-otp'),
        },
        {
          path: '/auth/forgot-password/reset-password',
          meta: {
            title: i18n.t('pageTitles.resetPassword'),
          },
          component: () => import('@/views/auth/reset-password'),
        },
        {
          path: '/auth/forgot-password/success',
          meta: {
            title: i18n.t('pageTitles.resetPassword'),
            authRequired: false,
          },
          component: () =>
            import(
              '@/components/cleanui/system/Auth/ConfirmationSuccessForgotPassword'
            ),
        },
        {
          path: '/auth/register',
          meta: {
            title: i18n.t('pageTitles.register'),
          },
          component: () => import('./views/auth/register'),
        },
        {
          path: '/auth/reg-conf/phone-number',
          meta: {
            title: i18n.t('pageTitles.registerConfirmation'),
          },
          component: () => import('./views/auth/reg-conf-phone-number'),
        },
        {
          path: '/auth/reg-conf/email',
          meta: {
            title: i18n.t('pageTitles.registerConfirmation'),
          },
          component: () => import('@/views/auth/reg-conf-email'),
        },
        {
          path: '/auth/reg-conf/otp',
          meta: {
            title: i18n.t('pageTitles.registerConfirmation'),
          },
          component: () => import('@/views/auth/reg-conf-otp'),
        },
        {
          path: '/auth/register/success',
          meta: {
            title: i18n.t('pageTitles.registrationSuccess'),
            authRequired: false,
          },
          component: () => import('@/views/auth/success-register'),
        },
        {
          path: '/auth/verify/:link/:uuid',
          component: () => import('@/views/auth/verify-email'),
        },
        {
          path: '/auth/confirmation/registered/invite-user/:uuid',
          meta: {
            title: 'Powerbiz - Registration Confirmation',

          },
          component: () => import('@/views/auth/confirmation-registered'),
        },
        {
          path: '/auth/confirmation/registered/invite-owner/:uuid',
          meta: {
            title: 'Powerbiz - Registration Confirmation',

          },
          component: () => import('@/views/auth/confirmation-registered'),
        },
        {
          path: '/auth/confirmation/invite-user/:uuid',
          meta: {
            title: i18n.t('pageTitles.userConfirmInvitation'),

          },
          component: () => import('@/views/auth/confirm-invite-user'),
        },
        {
          path: '/auth/confirmation/invite-owner/:uuid',
          meta: {
            title: i18n.t('pageTitles.userConfirmInvitation'),

          },
          component: () => import('@/views/auth/confirm-invite-user'),
        },
        {
          path: '/auth/confirmation/invite-owner-registered/:uuid',
          meta: {
            title: i18n.t('pageTitles.ownerConfirmInvitation'),

          },
          component: () => import('@/views/auth/confirm-invite-user'),
        },
        {
          path: '/auth/confirmation/invite-user-registered/:uuid',
          meta: {
            title: i18n.t('pageTitles.userConfirmInvitation'),

          },
          component: () => import('@/views/auth/confirm-invite-user'),
        },
        {
          path: '/auth/user-not-found',
          meta: {
            title: i18n.t('pageTitles.userNotFound'),
            authRequired: false,
          },
          component: () => import('@/views/auth/user-not-found'),
        },
      ],
    },

    {
      path: '/confirmation',
      meta: {
        title: 'Powerbiz - Powerbiz',
      },
      component: AuthLayout,
      children: [
        {
          path: '/confirmation/registered/success',
          meta: {
            title: i18n.t('pageTitles.registrationSuccess'),
          },
          component: () => import('@/views/auth/success-register'),
        },
        {
          path: '/confirmation/registered/timeout',
          meta: {
            title: i18n.t('pageTitles.timeout'),
          },
          component: () => import('@/views/auth/register-confirmation-timeout'),
        },
      ],
    },
    {
      path: '/public',
      meta: {
        title: 'Powerbiz - Full View Label',
      },
      component: PublicLayout,
      children: [
        {
          path: '/public/shipping-label',
          name: 'public-shipping-label',
          meta: {
            title: `Powerbiz - ${i18n.t('sideBar.fulfillment')}`,
            key: 'public-shipping-label',
          },
          component: () =>
            import('@/components/Fulfillment/PublicPrintLabel/index.vue'),
        },
        {
          path: '/public/order/:id',
          name: 'public-order-detail',
          meta: {
            title: 'Powerbiz - Order Detail',
            key: 'public-order-detail',
          },
          component: () =>
            import('@/components/Order/PublicDetail/index.vue'),
        },
      ],
    },
    {
      path: '/fulfillment',
      meta: {
        title: 'Powerbiz - Full View Label',
      },
      component: PublicLayout,
      children: [
        {
          path: '/fulfillment/labelfullpage',
          name: 'fulfillment-labelfullpage',
          meta: {
            title: `Powerbiz - ${i18n.t('sideBar.fulfillment')}`,
            key: 'fulfillment-labelfullpage',
          },
          component: () =>
            import('@/components/Fulfillment/FullViewLabel/index.vue'),
        },
        {
          path: '/fulfillment/bulk-shipping-label',
          name: 'fulfillment-shipping-label',
          meta: {
            title: `Powerbiz - ${i18n.t('sideBar.fulfillment')}`,
            key: 'fulfillment-bulk-shipping-label',
            authRequired: true,
          },
          component: () =>
            import('@/components/Fulfillment/BulkPrintLabel/index.vue'),
        },
        {
          path: '/fulfillment/bulk-picking-list',
          name: 'fulfillment-picking-list',
          meta: {
            title: `Powerbiz - ${i18n.t('sideBar.fulfillment')}`,
            key: 'fulfillment-bulk-picking-list',
            authRequired: true,
          },
          component: () =>
            import('@/components/Fulfillment/BulkPrintPicking/index.vue'),
        },
      ],
    },
    {
      path: '/self-register',
      component: () => import('./views/auth/self-register'),
    },








    {
      path: '*',
      redirect: 'auth/404',
      hidden: true,
    },
  ],
})

router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta && record.meta.authRequired)) {
    const exp = store.getters['user/expireIn']

    if (exp < new Date().getTime() / 1000) {
      store.commit('user/LOGOUT')
    }
    if (!store.getters['user/authorized']) {
      {
        return next({
          path: '/auth/login',
          query: { redirect: to.fullPath },
        })
      }
    }
  }

  if (store.state.user.restriction_base === 'Warehouse') {
    try {
      const ok = await checkWarehouseAccess(to, store)
      if (!ok) {
        return next({
          path: '/error/403',
          query: { ...to.query },
        })
      }
    } catch (e) {
      return next({
        path: '/error/403',
        query: { ...to.query },
      })
    }
  }

  if (to.path === '/') {
    return next({
      path: '/dashboard',
    })
  }
  next()
})

export default router
